export const ARTICLE = "ARTICLE";
export const VIDEO = "VIDEO";
export const LIVE = "LIVE";



/** WEBPACK FOOTER **
 ** ./src/constants/ArticleTypes.js
 **/